import React from 'react';
import { CalendarDaysIcon, ExternalLinkIcon } from 'lucide-react';
export function CalendarCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3102">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3103">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-3104">
          <CalendarDaysIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-3105" />
          <div className="flex-1" data-id="element-3106">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3107">
              Ready to get started?
            </p>
            <a href="https://www.fentonlakes.com/m7/42--refuse-to-be-a-victim.html" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3108">
              Register for this Class — Click Here
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-3109" />
        </div>
      </div>
    </div>;
}